import { useState } from 'react';
import { faqData } from '@/mocks/movies';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            关于被窝网电影的使用，您可能想了解的问题都在这里
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="border-b border-background-200 last:border-b-0"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between py-5 text-left cursor-pointer group"
              >
                <span className="font-heading text-base md:text-lg font-medium text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <div className={`w-6 h-6 flex items-center justify-center shrink-0 rounded-full transition-all ${
                  openIndex === index
                    ? 'bg-primary-500 text-white rotate-45'
                    : 'bg-background-200 text-foreground-500 group-hover:bg-primary-100 group-hover:text-primary-600'
                }`}>
                  <i className="ri-add-line text-sm"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 pb-5' : 'max-h-0'
                }`}
              >
                <p className="text-foreground-600 text-sm leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}